import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {changeField, deleteDB} from '../../../../modules/admin/database';
import styles from './styles/delete-modal.module.css';
import stylesModal from '../create/styles/modal.module.css';

import ButtonRadius50 from '../../../design-system/button/ButtonRadius50';
import ButtonText from '../../../design-system/button/ButtonText';

export default function DeleteModal({ selectedId, deletedId, closeSidebar, closeDeleteModal, handleReload }) {
    const dispatch = useDispatch();

    const { deleteResponse, deleteError, deleteLoading } = useSelector(({ database, loading }) => ({
        deleteResponse: database.deleteResponse,
        deleteError: database.deleteError,
        deleteLoading: loading['database/DELETE_DB']
    }));

    const initialize = () => {
        dispatch(changeField({ name: 'deleteResponse', value: null }));
        dispatch(changeField({ name: 'deleteError', value: null }));
    };

    const closeModalAndInitialize = () => {
        closeDeleteModal();
        initialize();
    };

    const requestDelete = () => {
        dispatch(deleteDB({ id: deletedId }));
    };

    const clickBackground = (e) => {
        if (e.target === e.currentTarget) {
            closeModalAndInitialize();
        }
    };

    const getButtonStyle = () => {
        if (deleteLoading) return { text: 'loading', handleClick: null };
        if (!deleteLoading && deleteError) return { text: '재시도', handleClick: requestDelete };

        return { text: '삭제', handleClick: requestDelete };
    };

    useEffect(() => {
        if (!deleteLoading && deleteResponse) {
            // 삭제된 DB가 현재 열린 DetailBox의 DB와 같으면 DetailBox 닫기
            if (selectedId === deletedId) {
                closeSidebar();
            }

            closeModalAndInitialize();
            handleReload();
        }
    }, [deleteResponse, deleteLoading]);

    return (
        <div className={stylesModal.wrapper} onClick={clickBackground}>
            <div className={stylesModal.containerModal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.wrapper}>
                    <div className={styles.boxTitle}>
                        <p className={styles.title}>해당 DB를 삭제할까요?</p>
                        <p className={styles.subTitle}>삭제된 연결은 복구할 수 없어요</p>
                    </div>
                    <div className={styles.boxButton}>
                        <ButtonText
                            height='H18'
                            text='취소'
                            handleClick={closeModalAndInitialize}
                        />
                        <ButtonRadius50
                            width='100px'
                            height='H40'
                            status='error'
                            text={getButtonStyle().text}
                            handleClick={getButtonStyle().handleClick}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
